import { graphql } from '@/gql'

export const GetJobSharesQuery = graphql(/* GraphQL */ `
  query JobShares($jobId: ID!) {
    job(id: $jobId) {
      company {
        settings {
          staffingAgencyManagesWorker
        }
      }
      shares(isActive: true, accountTypes: [WORKER, RECRUITER]) {
        data {
          ... on JobShare {
            id
            account {
              ...JobFormShareableWorker
              ...JobFormShareableRecruiter
            }
          }
        }
      }
    }
  }
`)
